import styled from 'styled-components';

export const Base = styled.div`
	background: ${(p) => p.theme.white};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	overflow: hidden;
	transition: all 0.2s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	@media (max-width: 500px) {
		display: flex;
		flex-direction: row;
	}
`;

export const Preview = styled.div`
	width: 100%;
	height: 180px;
	overflow: hidden;
	background: ${(p) => p.theme.gray[200]};

	&:hover img {
		filter: brightness(0.92);
		transform: scale(1.03);
	}

	@media (max-width: 500px) {
		width: 180px;
		min-width: 180px;
		height: auto;
	}
`;

export const PreviewImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: filter 0.2s ease, transform 0.2s ease;
`;

export const Body = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 0;
`;

export const Info = styled.div`
	padding: 14px;
`;

export const Name = styled.h3`
	font-size: 16px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
	margin: 4px 0 6px 0;
`;

export const Metadata = styled.div`
	font-size: 11px;
	color: ${(p) => p.theme.gray[400]};
	margin-top: 8px;
`;

export const Description = styled.p`
	font-size: 12px;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.5;
	margin: 4px 0 10px 0;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	min-height: calc(3 * 1.5em);
`;

export const Tags = styled.div`
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
	margin-top: 14px;
	margin-left: -2px;
`;

export const Tag = styled.span`
	padding: 3px 8px;
	background: ${(p) => p.theme.gray[200]};
	border-radius: 4px;
	font-size: 11px;
	color: ${(p) => p.theme.gray[600]};
`;

export const Links = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	margin-top: 10px;
	height: 16px;
`;

export const Link = styled.a`
	font-size: 11px;
	color: ${(p) => p.theme.gray[600]};
	text-decoration: none;
	cursor: default;

	&:hover {
		color: ${(p) => p.theme.gray[1000]};
	}
`;

export const LinkSeparator = styled.span`
	font-size: 11px;
	color: ${(p) => p.theme.gray[400]};
`;

export const ActionArea = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: -36px;
	padding: 0 14px 14px;
	pointer-events: none;

	> * {
		pointer-events: auto;
	}
`;
